var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#000018",
    fillOpacity: 0.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.353 9.521H10.647a3.803 3.803 0 00-3.803 3.803v5.352c0 2.1 1.703 3.804 3.803 3.804h10.706c2.1 0 3.803-1.703 3.803-3.804v-5.352c0-2.1-1.702-3.803-3.803-3.803zm-2.572 6.74l-5.008 2.388a.2.2 0 01-.287-.181v-4.926c0-.15.158-.248.292-.18l5.007 2.538a.2.2 0 01-.004.36z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/youtube.1d181933.svg";
export { SvgYoutube as ReactComponent };